import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HighlightSearch } from './utils/highlightPipe';
import { SortPipe } from './utils/sortPipe';
import { SpinnerComponent } from './spinner.component';
import { ApiErrorComponent } from './api-error.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'; // Angular Bootstrap - https://ng-bootstrap.github.io
import { JsonValidatorDirective } from './validators/json-validator.directive';
import { PasswordComplexityValidatorDirective } from './validators/password-complexity-validator.directive';
import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './not-found.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './account/register/register.component';
import { AccountActivationComponent } from './account/account-activation/account-activation.component';

import { UserService } from './services/user.service';
import { ForgottenPasswordComponent } from './account/forgotten-password/forgotten-password.component';
import { ResetPasswordComponent } from './account/reset-password/reset-password.component';
import { ModalComponent } from './modal/modal.component';
import { ThemeService } from 'ng2-charts';

@NgModule({
  imports: [CommonModule, NgbModule, FormsModule, RouterModule],
  declarations: [
    ApiErrorComponent,
    AppComponent,
    JsonValidatorDirective,
    LoginComponent,
    PageNotFoundComponent,
    PasswordComplexityValidatorDirective,
    SpinnerComponent,
    RegisterComponent,
    AccountActivationComponent,
    ForgottenPasswordComponent,
    ResetPasswordComponent,
    HighlightSearch,
    SortPipe,
    ModalComponent,
  ],
  exports: [
    ApiErrorComponent,
    AppComponent,
    JsonValidatorDirective,
    LoginComponent,
    PageNotFoundComponent,
    PasswordComplexityValidatorDirective,
    SpinnerComponent,
    RegisterComponent,
    AccountActivationComponent,
    ForgottenPasswordComponent,
    ResetPasswordComponent,
    HighlightSearch,
    ModalComponent,
    SortPipe,
  ],
  providers: [UserService, ThemeService],
})
export class SharedModule {}
